import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../../MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";

// namespace SlotGames
// {

	export class BambooSecretsFillingPot_2Screen extends SlotGameType1_2Screen {

        // protected override panelFactory:IPanelFactory = new BambooSecretsFillingPotPanelFactory();
		protected override helpFactory:IHelpFactory = new BambooSecretsFillingPotHelpFactory();
        protected override skinAttachmentFillingPotFeature: number = 3;
        

        
        //LED COLOR
		protected override ColorLed:string="255,255,0\n";
        protected override panelColor: ButtonColors={
			backgroundButtonColor: "linear-gradient(rgb(0, 0, 0), rgb(1, 80, 0), rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%"
		};
		
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "BambooSecretsFillingPot");
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
            this.fillingPotFeature?.SetSkin(this.skinAttachmentFillingPotFeature);		
        }
        
        //SEND COLOR FOR SRA
    protected override color: RewardColor =
    {
        color: "#F9F8E2",
        coloroutherStroke: "#013809",
        colorinnerStroke: "#0EE104"
    }

		
    }
    

	


//Panel Colorized merged
class BambooSecretsFillingPotPanelFactory implements IPanelFactory
{
    public CreateNewPanel(params: PanelParams):Panel
    {
        return new BambooSecretsFillingPotPanel(params);
    }
}

class BambooSecretsFillingPotPanel extends Panel
{
    protected override ButtonBackground():ButtonColors
    {
        let color:ButtonColors ={
            backgroundButtonColor: "linear-gradient(rgb(1, 71, 0),rgb(1, 79, 0), rgb(3, 173, 0),rgb(1, 79, 0),rgb(1, 71, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor:"linear-gradient(to left , transparent, chartreuse,transparent ) 0 10 100%",
        };
        
        return color;
    }

}

class BambooSecretsFillingPotHelpFactory implements IHelpFactory
{
    public CreateNewHelp(params: HelpParameters):Help
    {
        return new   BambooSecretsFillingPotHelp(params);
    }
}

class BambooSecretsFillingPotHelp extends Help
{
    protected override BackgroundPanel():HelpPanelColor
    {
        let color:HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(1, 71, 0),rgb(1, 79, 0), rgb(3, 173, 0),rgb(1, 79, 0),rgb(1, 71, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}
